module.exports = __webpack_public_path__ + "static/img/gg.dcc5b0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gg.png
// module id = 0mO1
// module chunks = 1